import { render, staticRenderFns } from "./problemPage.vue?vue&type=template&id=3748c5ab&"
import script from "./problemPage.vue?vue&type=script&lang=js&"
export * from "./problemPage.vue?vue&type=script&lang=js&"
import style0 from "./problemPage.vue?vue&type=style&index=0&id=3748c5ab&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports